import type { CarouselConfig, MediaConfig } from './types';

const defaultMediaConfig: MediaConfig = {
  slidesToShow: 1,
  slideGap: '16px',
  transitionDuration: 500,
  transitionDurationAutoplay: undefined,
  transitionDurationManual: undefined,
  transitionTimingFunction: 'ease',
  autoplay: true,
  autoplayInterval: 5000,
  autoplayDirection: 'left',
  pauseAutoplayOnHover: false,
  infinite: true,
};

export const defaultCarouselConfig: CarouselConfig = {
  all: defaultMediaConfig,
};

export const createConfig = (carouselConfig: CarouselConfig): MediaConfig =>
  typeof window === 'undefined'
    ? defaultMediaConfig
    : Object.entries(carouselConfig).reduce(
        (config, [query, mediaConfig]) => {
          if (matchMedia(query).matches) config = { ...config, ...mediaConfig };
          return config;
        },
        { ...defaultMediaConfig },
      );
